<template>
  <div >测试关系管理页</div>
</template>

<script>
export default {
  name: 'RelationManage',
  props: {
    msg: String,
  },
  data() {
    return {};
  },
  mounted() {

  },
  methods: {
  },
};
</script>

<style scoped>
</style>
